import { useCallback, useEffect, useState } from 'react';
import { get } from './request';

type ListResponse<T> = T[] | {
  data?: T[];
  results?: T[];
};

function extractRows<T>(payload: ListResponse<T>): T[] {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.results)) return payload.results;
  return [];
}

export function useAttivitaData<T>(data: string) {
  const [rows, setRows] = useState<T[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const refetch = useCallback(() => {
    if (data) setReloadKey(value => value + 1);
  }, [data]);

  useEffect(() => {
    let active = true;

    if (!data) {
      setRows([]);
      setError(null);
      setLoading(false);
      return () => {
        active = false;
      };
    }

    setLoading(true);
    setError(null);

    get<ListResponse<T>>('/progetti/attivitaData', { data })
      .then(response => {
        if (active) setRows(extractRows(response.data));
      })
      .catch(err => {
        if (!active) return;
        setRows([]);
        setError(err instanceof Error ? err.message : 'Errore durante il caricamento delle attività');
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [data, reloadKey]);

  return { rows, loading, error, refetch };
}
